import { render } from "./FAQForm.vue?vue&type=template&id=5eb47a63&scoped=true"
import script from "./FAQForm.vue?vue&type=script&lang=js"
export * from "./FAQForm.vue?vue&type=script&lang=js"

import "./FAQForm.vue?vue&type=style&index=0&id=5eb47a63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb47a63"]])

export default __exports__